export default "__VITE_ASSET__DX$xmgQk__"